import Chaplin from 'chaplin';
import Activity from 'ef/models/activity';
import _ from 'lodash';

/**
 * EF.Collections.ActivitiesCollection
 * Collection for holding and finding the activities
 */
const ActivitiesCollection = Chaplin.Collection.extend({
  model: Activity,

  modelId: function (attrs) {
    return attrs.key;
  },

  comparator: 'index',

  initialize: function (attrs, options) {
    this.module = options.module;
  },

  // # getByKey
  //
  // returns Activity by key
  getActivityByKey: function (key) {
    return this.find(function (activity) {
      return activity.get('key') === key;
    });
  },

  completed: function () {
    return this.filter(function (a) {
      return a.get('completed');
    });
  },

  back: function (activity) {
    const idx = activity.get('index');
    const models = this.toArray().reverse();
    const model = _.find(models, function (a) {
      return a.get('index') < idx;
    });
    if (model) {
      return model;
    } else {
      return false;
    }
  },
});

export default ActivitiesCollection;
